import { defineComponent, ref, onMounted } from "@vue/composition-api";
import TheNavbar from "@/components/TheNavbar/TheNavbar.vue";

export default defineComponent({
  name: "bootstrapGrid",
  components: {
    TheNavbar,
  },

  setup() {
    const dataLoaded = ref(false);

    onMounted(() => {
      dataLoaded.value = true;
    });

    return {
      dataLoaded,
    };
  },
});
